export const proyectos = [
    ,{
        id: 4,
        distrito: 1,
        nombre: 'GUARNICIONES Y BANQUETA DE LA CALLE ECOSISTEMAS COL LUZ Y ESPERANZA', 
    },{
        id: 5,
        distrito: 1,
        nombre: 'DRENAJE EN LA CALLE ECOSISTEMAS COL LUZ Y ESPERANZA', 
    },{
        id: 12,
        distrito: 1,
        nombre: 'SEMAFORO EN VIALIDAD (CRUCE SEGURO "LA CUADRA")', 
    },{
        id: 21,
        distrito: 1,
        nombre: 'PAVIMENTACION INTEGRAL DE LA CALLE C1 COLONIA UNIDAD DE GUADALUPE', 
    },{
        id: 26,
        distrito: 1,
        nombre: 'PAVIMENTACIÓN DE LA CALLE DE LA CRUZ COL LUZ Y ESPERANZA', 
    },{
        id: 27,
        distrito: 1,
        nombre: 'PAVIMENTACIÓN DE LA CALLE ECOSISTEMAS COL LUZ Y ESPERANZA', 
    },{
        id: 28,
        distrito: 1,
        nombre: 'CORDONERIA Y BANQUETA DE LA CALLE AURORA BOREAL COL LUZ Y ESPERANZA', 
    },{
        id: 59,
        distrito: 1,
        nombre: 'CONSTRUCCIÓN DE AULA DE USOS MULTIPLES JARDIN DE NIÑOS "PAPALOTE"', 
    },{
        id: 60,
        distrito: 1,
        nombre: 'CONSTRUCCIÓN DE DOMO ESCOLAR EN CENDI "JOSE REVUELTAS"', 
    },{
        id: 62,
        distrito: 1,
        nombre: 'CANCHA DE FUTBOL RAPIDO PARA EL PLANTEL CONALEP DURANGO 130', 
    },{
        id: 115,
        distrito: 1,
        nombre: 'REHABILITACIÓN DE JARDIN DE LA COL SILVESTRE REVUELTAS', 
    },{
        id: 120,
        distrito: 1,
        nombre: 'REHABILITACIÓN DE LA PLAZA DE LA LOC CHUPADEROS', 
    },{
        id: 123,
        distrito: 1,
        nombre: 'PLANCHA DE PATIO CIVICO DE LA ESCUELA PRIMARIA QUINCE DE MAYO', 
    },{
        id: 138,
        distrito: 1,
        nombre: 'DOMO ESCOLAR PARA EL JARDIN DE NIÑOS "SRA DIANA LAURA RIOJAS REYES"', 
    },{
        id: 145,
        distrito: 1,
        nombre: 'CONSTRUCCION DE LA CANCHA DE FUTBOL 7 UNIDAD DEPORTIVA DANIEL CORRAL NUNEZ "LA FORESTAL"', 
    },{
        id: 149,
        distrito: 1,
        nombre: 'SEÑALIZACION EN CALLE PERU', 
    },{
        id: 157,
        distrito: 1,
        nombre: 'PAVIMENTACIÓN DE LA CALLE SACRIFICIO DE LA COL ROSAS DEL TEPEYAC', 
    },{
        id: 158,
        distrito: 1,
        nombre: 'BARDA PERIMETRAL DEL TELEBACHILLERATO DE LA LOC SAN VICENTE DE CHUPADEROS', 
    },{
        id: 179,
        distrito: 1,
        nombre: 'CANCHA DE FUTBOL RAPIDO EN LA ESCUELA SECUNDARIA "JAIME TORRES BODET"', 
    },{
        id: 225,
        distrito: 1,
        nombre: 'CANCHA DE FUTBOL ESCUELA PRIMARIA EVA SAMANO DE LOPEZ MATEOS', 
    },{
        id: 228,
        distrito: 1,
        nombre: 'SENALIZACION EN CALLE REPUBLICA DE ARGENTINA', 
    },{
        id: 229,
        distrito: 1,
        nombre: 'REHABLITACIÓN DEL GIMNASIO AUDITORIO "LA FORESTAL" COBAED PLANTTEL 01', 
    },{
        id: 232,
        distrito: 1,
        nombre: 'REHABILITACIÓN DEL CAMPO DE BEISBOL DE LA UNIDAD DEPORTIVA JOSÉ REVUELTAS', 
    },{
        id: 257,
        distrito: 1,
        nombre: 'POSTE DE LUZ EN CALLE DEL ALBA COLONIA LUZ Y ESPERANZA', 
    },
    {
        id: 271,
        distrito: 1,
        nombre: 'BARDA PERIMETRAL EN EL JARDIN DE NINOS ANNA FREUD', 
    },{
        id: 273,
        distrito: 1,
        nombre: 'RECUPERACION INTEGRAL (CONSTRUCCIÓN DE DOMO) DE SKATEPARK 360', 
    },{
        id: 333,
        distrito: 1,
        nombre: 'CONSTRUCCION DE CANCHA FUTBOL PRIMARIA DRA MARGARITA GOMEZ PALACIO', 
    },{
        id: 385,
        distrito: 1,
        nombre: 'REHABILITACION DE LA CANCHA FRACC SAN JUAN', 
    },{
        id: 392,
        distrito: 1,
        nombre: 'DOMO EN LA UNIDAD DEPORTIVA DE LA CUADRA DE FERROCARRIL', 
    },{
        id: 434,
        distrito: 1,
        nombre: 'TRABAJOS DE REHABILITACION DEL JARDIN DE NIÑOS MARTIN GONZALEZ VAZQUEZ', 
    },{
        id: 436,
        distrito: 1,
        nombre: 'REHABILITACION DEL AREA VERDE FRACC PASO REAL II', 
    },{
        id: 437,
        distrito: 1,
        nombre: 'REHABILITACION ASFALTICA DE LA CALLE CAMINO DE LOS GENERALES FRACC PASO REAL', 
    },{
        id: 468,
        distrito: 1,
        nombre: 'REHABILITACION DE PASTO SINTETICO DE LA CANCHA MULTIDEPORTIVO CARLOS LUNA', 
    },{
        id: 473,
        distrito: 1,
        nombre: 'REHABILITACION DE LA UNIDAD DEPORTIVA ACEREROS', 
    },{
        id: 475,
        distrito: 1,
        nombre: 'REHABILITACION DE PISOS Y BANQUETAS DEL JARDIN DE NINOS ANTONIO GAXIOLA', 
    },{
        id: 494,
        distrito: 1,
        nombre: 'CONSTRUCCION DE GUARNICIONES Y BANQUETAS COL PRI', 
    },{
        id: 444,
        distrito: 1,
        nombre: 'REMODELACIÓN DE LA PLAZA "LA TINAJA"', 
    },{
        id: 520,
        distrito: 1,
        nombre: 'SEÑALIZACION EN CALLE LOS CIPRESES', 
    },{
        id: 522,
        distrito: 1,
        nombre: 'PAVIMENTACION CALLE TOMAS URBINA COL FRANCISCO ZARCO', 
    },{
        id: 528,
        distrito: 1,
        nombre: 'SENALAMIENTO EN CALLE DOROTEO ARANGO', 
    },
]